import { LinkButton, TooltipDesktop } from '@cian/ui-kit';
import { IconFilePdf16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { trackDownloadOfferPdf } from './tracking';
import { useOfferContext } from '../../../../context';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';

interface IProps {
  isHovered: boolean;
}

export const DownloadPDFControlContainer = ({ isHovered }: IProps) => {
  const { offer, position } = useOfferContext();

  const { fullUrl, id } = offer;

  const url = React.useMemo(() => (fullUrl ? fullUrl.replace('.ru/', '.ru/export/pdf/') : ''), [fullUrl]);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    trackDownloadOfferPdf(id, position);
  };

  if (!url) {
    return null;
  }

  return (
    <ControlWrapper visible={isHovered}>
      <TooltipDesktop theme="black" placement="left" title="Скачать PDF">
        <LinkButton
          data-mark="DownloadPDFControl"
          target="_blank"
          size="XS"
          theme="stroke_secondary"
          onClick={handleClick}
          href={url}
          beforeIcon={<IconFilePdf16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
